import { createSlice } from "@reduxjs/toolkit";
import { moderatorApi } from "../apis/moderatorApi";
import { authApi } from "../apis/authApi";

const initialState = {
    Flag: false,
    Clients: [],
    Moderators: [],
    Questions: [],
};

const moderatorSlice = createSlice({
    name: "moderator",
    initialState,
    reducers: {
        resetAdminState: () => initialState,
    },
    extraReducers: (builder) => {
        builder.addMatcher(authApi.endpoints.logout.matchFulfilled, (state) => {
            state.Flag = false;
            state.Clients = [];
            state.Moderators = [];
            state.Admins = [];
            state.Questions = [];
        })
        .addMatcher(moderatorApi.endpoints.fetchData.matchFulfilled, (state, action) => {
            const { Clients, Moderators, Admins, Questions } = action.payload;
            
            state.Flag = true;
            state.Clients = Clients || [];
            state.Moderators = Moderators || [];
            state.Admins = Admins || [];
            state.Questions = Questions || [];
        })
        .addMatcher(moderatorApi.endpoints.deleteClient.matchFulfilled, (state, action) => {
            state.Clients = state.Clients.filter(client => client.id !== action.payload);
        })
    },
});

export const { resetAdminState } = moderatorSlice.actions;
export default moderatorSlice.reducer;